import TreeViewContainer from "../../../Components/BonusUi/TreeView/TreeView"

const TreeView = () => {
  return (
    <div className="page-body">
      <TreeViewContainer />
    </div>
  )
}

export default TreeView